import {ClockType} from '@/common/constants/units';

export function minutesToTimeString(minutes: number, clockType: ClockType) {
	return new Date(0, 0, 0, 0, minutes).toLocaleTimeString('en-gb', {
		minute: 'numeric',
		hour: 'numeric',
		hour12: clockType === ClockType['12h'],
	});
}
